/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Container as e}from"../Container.js";import{clipTechnique as r}from"./shaderGraph/techniques/clip/ClipTechnique.js";class i extends e{renderChildren(e){e.painter.setPipelineState(null);for(const i of this._clips)r.render(e,i)}}export{i as default};
